import UpdateAgendaItemData from "@/domain/entities/agenda/UpdateAgendaItemData";
import { queryKeys } from "@/lib/queryKeys";
import updateAgendaItemDataMapper from "@/mappers/agenda/updateAgendaItemDataMapper";
import { useSdk } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useErrorToast from "../utils/useErrorToast";

const useUpdateAgendaEvent = (onSuccess?: () => void) => {
    const { agendaManager } = useSdk();
    const showError = useErrorToast();
    const queryClient = useQueryClient();

    const updateAgendaEvent = useMutation<
        void,
        unknown,
        { agendaItemId: string; updateAgendaItemData: UpdateAgendaItemData }
    >({
        mutationFn: async ({ agendaItemId, updateAgendaItemData }) => {
            if (!agendaManager) {
                throw new Error("Agenda manager is not set");
            }

            const updateDataToSDK =
                updateAgendaItemDataMapper(updateAgendaItemData);

            const updated = await agendaManager.updateAgendaItem(
                agendaItemId,
                updateDataToSDK,
            );

            if (!updated) {
                throw new Error("Agenda item update refused by the provider");
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.agendaEvents.all(),
            });
            onSuccess?.();
        },
        onError: (error) => {
            console.error(error);
            showError({
                titleTranslationKey: "errors.agenda.update",
            });
        },
    });

    return { updateAgendaEvent };
};

export default useUpdateAgendaEvent;
